import { render, staticRenderFns } from "./ViewTaxGroupComponent.vue?vue&type=template&id=10b84ab0&"
import script from "./ViewTaxGroupComponent.vue?vue&type=script&lang=js&"
export * from "./ViewTaxGroupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports